export default "__VITE_ASSET__D39xxhEG__"